import { c as _c } from "react/compiler-runtime";
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { operations } from './generated/selfCare';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { URLS } from '@/constants/api';
import { apiSelfCareFetcher } from '../fetcher';
type PublicRewardsResponse = operations['publicRewardsPartnerPromocodesOffers']['responses']['200']['content']['application/json'] | undefined;
type QueryOpts = Omit<UseQueryOptions<unknown, unknown, PublicRewardsResponse>, 'queryKey'>;
type QueryParams = operations['publicRewardsPartnerPromocodesOffers']['parameters']['query'];
export function usePublicRewards(params, opts) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = QUERY_KEYS.publicRewards();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== params) {
    t1 = async () => {
      const res = await apiSelfCareFetcher(URLS.publicRewards, {
        searchParams: params
      });
      return res.json;
    };
    $[1] = params;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== opts || $[4] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...opts
    };
    $[3] = opts;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useQuery(t2);
}